import React, { useCallback, useEffect, useRef } from 'react';
import { Box, Grid, Paper, Typography } from '@material-ui/core';
import { Form } from '@unform/web';
import { toast } from 'react-toastify';
import { useHistory, useParams } from 'react-router-dom';
import {
  extractValidationErrors,
  ValidationError,
  changeUserPassword,
  getUser,
  userChangePasswordForm,
  findUserByResetPasswordToken,
  FindUserByResetPasswordTokenParams,
} from '@bforms-web/common';

import { USERS_ROUTE, SIGNIN_ROUTE } from '../../../constants';
import { useLoading } from '../../../contexts/loading.context';
import Button from '../../Button';
import Input from '../../Input';
import PageTitle from '../../PageTitle';

import { useStyles } from './styles';

interface Password {
  newPassword: '';
  confirmNewPassword: '',
}

export default function UserChangePassword(): JSX.Element {
  const classes = useStyles();
  const formRef = useRef({} as any);
  const { isLoading, showLoading, hideLoading } = useLoading();
  const { push } = useHistory();
  let { id } = useParams<{ id: string }>();
  const { token } = useParams<{ token: string }>();
  const resetToken: FindUserByResetPasswordTokenParams = {
    resetPasswordToken: '',
  }
  resetToken.resetPasswordToken = token;
  const validLinkRef = useRef(true);

  useEffect(() => {
    showLoading();
    async function runAsync() {
      try {
        const userByToken = await findUserByResetPasswordToken.execute(resetToken);
        if(userByToken){
         id = userByToken.id;
        }else if(!userByToken && !id){
          validLinkRef.current = false;
          toast.error('Link inválido');
        }
      } catch (err) {
        console.log(err);
      } finally {
        hideLoading();
      }
    }
    runAsync();
  }, []);

  const handleSubmit = useCallback(
    (data: Password) => {
      showLoading();
      async function runAsync() {
        try {          
          await userChangePasswordForm.validate(data, {
            abortEarly: false,
          })
          const user = await getUser.execute(id);
          user.password = data.newPassword;
          await changeUserPassword.execute({...user})
          toast.success('Senha alterada com sucesso');
          push(USERS_ROUTE);
        } catch (err) {
          console.log(err);
          let errors = {};
          if (err instanceof ValidationError) {
            errors = extractValidationErrors(err);
            formRef.current.setErrors(errors);
          } else {
            toast.error('Falha ao alterar senha');
          }
        } finally {
          hideLoading();
        }
      }
      runAsync();
    },
    [id],
  );
   
  return (
    <Box className={classes.container}>
      <PageTitle>{ validLinkRef.current ? 'Alterar senha' : '' }</PageTitle>
      <br />
      {validLinkRef.current &&(
      <Form ref={formRef} onSubmit={handleSubmit}>
        <Paper className={classes.container}>
        <Typography>
        <p>Sua senha deve conter ao menos 8 caracteres</p>
      </Typography>
          <Grid container spacing={2} direction="column">
            <Grid item xs={12} sm="auto">
              <Input
                name="newPassword"
                variant="outlined"
                label={'Nova senha'}
                type="password"
                className={classes.input}
                disabled={isLoading}
              />
            </Grid>
            <Grid item xs={12} sm="auto">
              <Input
                name="confirmNewPassword"
                variant="outlined"
                label={'Confirmar nova senha'}
                type="password"
                className={classes.input}
                disabled={isLoading}
              />
            </Grid>
            <Grid item>
              <Button disabled={isLoading} type="submit" variant="contained" color="primary">
                {'Alterar'}
              </Button>
            </Grid>
          </Grid>
        </Paper>
      </Form>
      )}
      {!validLinkRef.current && (
        <Button onClick={() => { push(SIGNIN_ROUTE) }} type="submit" variant="contained" color="primary">
          {'Voltar'}
        </Button>
      )}
    </Box>
  );
}
